import { useEffect } from 'react'
import { useFlowStore } from '../store'
import type { SidebarComponentProps } from '../types'
import { retiredNodeReason } from '../utils/retired-nodes'

export const RetiredNodeSidebar = ({
  selectedNode,
}: SidebarComponentProps<Record<string, unknown>>) => {
  // No form mounts here, so drop the previous node's: the unsaved-changes check reads it.
  useEffect(() => {
    useFlowStore.getState().setSidebarFormInstance(null)
  }, [])
  return (
    <p className="text-s-400 text-secondary" data-testid="text-sidebar-retired-node">
      {retiredNodeReason(selectedNode.type)}
    </p>
  )
}
